import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Modal, Button,Alert, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from 'axios';
import { BASE_URL, NODE_API_URL } from '../../../env_config';
import { toAbsoluteUrl } from "../../_helpers";
import AdvancedTag from "./AdvancedTag";
import renderShadeLabel from "./ShadeTag";
import renderMilkyLabel from "./MilkyTag";
import renderEyecleanLabel from "./EyecleanTag";
import renderGrowthTypeLabel from "./GrowthTypeCheck";
import Select from "react-select";
import { FaEdit, FaInfoCircle, FaRegEdit, FaSave } from "react-icons/fa";
import renderLusterLabel from "./lusterTag";
import OpenChips from "./openTag";
import Availability from "./Availability";
import { Logoutuser } from "../controls/Logoutuser";
import CertificateLink from "./CertificateLink";
import DiamondTypeTag from "./DiamondTypeTag";
// import { toAbsoluteUrl } from "../../_helpers";
const customShadeStyles = (selectedOption) => ({
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
        width: '200px', // Set the dropdown width to 200px
        minWidth: '200px', // Ensure the menu doesn't shrink below 200px
        cursor: 'pointer !important'
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    control: (provided) => ({
        ...provided,
        minHeight: '28px',
        height: '28px',
        width: '120px', // Set the control width to 200px
        borderRadius: '0.42rem', // Round corners for the "tag style"
        border: 'none',
        backgroundColor: selectedOption?'#f3f5f9':'#ffe2e5', // Apply dynamic background color
        color: selectedOption ? selectedOption.color : '#333', // Dynamic text color
        padding:0,
        marginBottom:5,
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center', // Align items horizontally (for tags)
    }),
    singleValue: (provided) => ({
        ...provided,
        fontSize: '10px',
        fontWeight:'bold',
        textAlign:'center',
        padding:0,
        color: selectedOption ? selectedOption.color : '#333', // Dynamic text color
    }),
   dropdownIndicator: (provided) => ({
        ...provided,
        padding: '0 5px',
    }),
    indicatorSeparator: () => ({
        display: 'none', // Hide the separator line
    }),
    clearIndicator: (provided) => ({
        ...provided,
    }),
    placeholder: (provided, state) => ({
        ...provided,
        color: !selectedOption?'#F64E60':"",
      })
});


const initialValues = {};

const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
        <>
            {/* <div
                ref={innerRef}
                {...innerProps}
                style={{
                    ...props.getStyles('option', props),
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px 10px',
                    backgroundColor: data.color || '#ddd', // Default background if no color is provided
                    color: '#fff',
                    borderRadius: '20px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    margin: '2px 0',
                }}
            >
                {data.label}
            </div> */}
            <div className="w-100 px-2 mb-1 advTag">
                <div ref={innerRef}
                    {...innerProps} style={{color:data.color}} className={`label label-light-primary label-light-shade_${data.label.toLowerCase().replace(' ', '_')} label-pill label-inline label-sm mr-1 font-weight-bold px-2`}>{data.label}</div>
            </div>
        </>
    );
};
export const HoldApprove = (props) => {
    const [showPopup, setShowPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errmessage,setErrorMessage] = useState()
    // console.log(props)
    useEffect(() => {
        setShowPopup(props.show);
    }, [props.show]);
    const [yupValidationSchema,setYupValidationSchema] = useState({})
    const [UiData,setUiData] = useState({})
    const OrderSchema = Yup.object().shape(yupValidationSchema);

    const enableLoading = () => {
        setLoading(true);
    };

    const disableLoading = () => {
        setLoading(false);
    };

    const getInputClasses = (fieldname) => {
        if (formik.touched[fieldname] && formik.errors[fieldname]) {
            return "is-invalid";
        }

        if (formik.touched[fieldname] && !formik.errors[fieldname]) {
            return "is-valid";
        }

        return "";
    };
    const formik = useFormik({
        initialValues,
        validationSchema: OrderSchema,
        onSubmit: (values, { setStatus, setSubmitting,resetForm }) => {
            enableLoading();
            setSubmitting(true);
            let comment = ""
            let DbObject = {}
            for(let keys in UiData){
                if(UiData[keys] && UiData[keys]["dbappend"] && values[keys]){
                    if(UiData[keys].type === "multiselect"){
                        let splitmultivalues = values[keys].split(", ")
                        let multicomments = []
                        for(let i = 0; i < splitmultivalues.length; i++){
                            let getcommentshortforms = UiData[keys].options.find(val => val.value === splitmultivalues[i])
                            if(getcommentshortforms){
                                multicomments.push(getcommentshortforms.shortLabel)
                            }
                        }
                        comment += `${UiData[keys].name}: ${multicomments.toString()} `
                        DbObject[UiData[keys].dbcolumnname] = multicomments.toString()
                    }
                    else if(UiData[keys].type === "select"){
                        let getcommentshortforms = UiData[keys].options.find(val => val.value === values[keys])
                        if(getcommentshortforms){
                            comment += `${UiData[keys].name}: ${getcommentshortforms.shortLabel} `
                            DbObject[UiData[keys].dbcolumnname] = getcommentshortforms.shortLabel
                        }
                    }
                    else if(UiData[keys].type === "text" || UiData[keys].type === "comment"){
                        comment += `${UiData[keys].name}: ${values[keys]} `
                        DbObject[UiData[keys].dbcolumnname] = values[keys]
                    }
                }
            }
            const finalData = {
                "userid":props.data.clientId,
                "diamond_type": props.data.diamondType === "L" ? "L" : "N" ,
                "certi_no":props.data.certiNo,
                "statsusid":props.data.statsusid,
                "is_hold":`${props.data.holdStatus}`,
                "hold_duration":props.data.holdTime,
                "comment":comment,
                "cgi":props.data.confirmGoodsId,
                "DbObject":DbObject
            }
            // console.log(finalData)
            
            axios({
                method: "POST",
                url: `${process.env.REACT_APP_ENV === "production" ? "https://api.oasis.diamondsoncall.online" : "https://api.immitation.diamondsupload.com"}/admin/supplierStatus`,
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("authToken")}`
                  },
                data: finalData,
            }).then((res) => {
                resetForm()
                disableLoading();
                setSubmitting(false);
                // console.log("res123",res)
                if (res && res.data) {
                //     // setData(res.data.data)
                // props.holdListData();
                    props.onHide();
                    props.setTemp(!props.temp)
                    if(props.data.statsusid){
                        props.setSuccessMsg(`Your ${props.data.orderType} approved for  stone id : ${props.data.loatNo}`)
                    }
                    else{
                        props.setErrorMsg(`Your ${props.data.orderType} cancelled for  stone id : ${props.data.loatNo}`)
                    }
                    props.setLoader(true)
                    // window.location.reload()
                    setErrorMessage()
                }
            }).catch(error => {
                setSubmitting(false);
                // console.log(error.response.data.error,"ERROR")
                disableLoading();
                setErrorMessage(error.response.data.error)
                if(error?.response?.data?.message === "UnAuthorized!"){
                    Logoutuser();
                  }
            })
        },
      
    });
    useEffect(() => {
        if(props?.data && !Array.isArray(props?.data) && props?.data?.UIData){
            setUiData(props?.data?.UIData)
            const createValidationSchema = (ValidationSchema) => {
                const schema = {};
                
                for (const [fieldName, fieldConfig] of Object.entries(ValidationSchema)) {
                 if(fieldConfig.type === "boolean"){
                    schema[fieldName] = Yup.boolean();
                 }   
                 else if (fieldConfig.required) {
                    schema[fieldName] = Yup.string().required(fieldConfig.message);
                  } else {
                    schema[fieldName] = Yup.string();
                  }
                }
                
                return schema;
              };
            const yupValidationSchema = createValidationSchema(props?.data?.UIData);
            setYupValidationSchema(yupValidationSchema)
            let options = {}
            for(let keys in props?.data?.UIData){
            if(keys && props?.data?.UIData[keys]?.options){
                options[keys] = props?.data?.UIData[keys].options
            }
            formik.setFieldValue(keys,props?.data?.UIData[keys]?.defaultValue || "")
            }
        }
    },[props.data])
    // console.log(formik.values,"VALUESSSS")
    const closeModel = () => {
        props.onHide();
        setShowPopup(false);
        formik.resetForm()
    };
    // console.log(props.data.createdDate,"props.data.createdDate")
    const customOpenStyles = (selectedOptions,selectedData) => ({
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            width: '200px',
            minWidth: '200px',
            cursor: 'pointer !important'
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
        control: (provided, state) => ({
            ...provided,
            minHeight: '32px',
            height: '32x',
            minWidth: '120px',
            width: 'auto',
            borderRadius: '0.42rem',
            border: 'none',
            backgroundColor: selectedData?'#f3f5f9':'#ffe2e5',
            padding: '0 5px',
            marginBottom: 5,
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
            boxShadow: state.isFocused ? '0 0 0 1px #3699FF' : 'none',
            overflow: 'hidden', // Changed from auto to hidden
            '::-webkit-scrollbar': {
                height: '3px', // Slimmer scrollbar
            },
            '::-webkit-scrollbar-thumb': {
                backgroundColor: '#B5B5C3',
                borderRadius: '3px',
            },
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '0 2px',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            overflowY: 'hidden',
            width: 'calc(100% - 30px)', // Account for dropdown indicator
            display: 'flex',
            alignItems: 'center',
            gap: '2px',
            scrollbarWidth: 'thin', // For Firefox
            '::-webkit-scrollbar': {
                height: '3px',
            },
            '::-webkit-scrollbar-thumb': {
                backgroundColor: '#B5B5C3',
                borderRadius: '3px',
            },
        }),
        multiValue: (provided, state) => {
            // Find the option that matches this value
            const option = selectedOptions.find(opt => opt.value === state.data.value);
            return {
                ...provided,
                backgroundColor: 'white',
                borderRadius: '0.42rem',
                margin: 0,
                flexShrink: 0,
            };
        },
        multiValueLabel: (provided, state) => {
            const option = selectedOptions.find(opt => opt.value === state.data.value);
            return {
                ...provided,
                fontSize: '10px',
                padding: '2px 6px',
                color: option?.color || '#333', // Use the color from selectedOptions for text
                whiteSpace: 'nowrap',
            };
        },
        multiValueRemove: (provided) => ({
            ...provided,
            padding: '0 2px',
            ':hover': {
                backgroundColor: 'transparent',
                color: '#ff0000',
            },
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '0 5px',
            flexShrink: 0,
            alignSelf: 'center',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '28px',
            alignItems: 'center',
        }),
        indicatorSeparator: () => ({
            display: 'none',
        }),
        clearIndicator: (provided) => ({
            ...provided,
            padding: '0 2px',
        }),
        input: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0,
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: '12px',
            padding: '4px 8px',
            backgroundColor: state.isSelected ? '#3699FF' : 'white',
            color: state.isSelected ? 'white' : '#333',
            ':hover': {
                backgroundColor: state.isSelected ? '#3699FF' : '#f3f5f9',
            },
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: !selectedData?'#F64E60':"",
          })
    });
    const getChipStyles = (options, optionValue) => {
        // Find the option in the array that matches the value
        const option = options.find(opt => opt.value === optionValue);

        // Determine the text color - use white for dark colors, black for light colors
        const textColor = option?.color;

        let style = {
            display: 'inline-flex',
            alignItems: 'center',
            fontSize: '10px',
            padding: '2px 6px',
            borderRadius: '4px', // rounded corners for chip look
            backgroundColor: "#f4f4f4",
            color: textColor || "#000",
            whiteSpace: 'nowrap',
            margin: '2px',
            boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
        };
        return (
            <>
                {option ?
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip">
                                {option.label}
                            </Tooltip>
                        }
                    >
                        <span style={style}>
                            {option.shortLabel}
                        </span>
                    </OverlayTrigger>
                    : ""}
            </>
        )
    };

    return (
        <div>
            <Modal
                show={showPopup}
                onHide={props.onHide}
                backdrop="static"
                keyboard={false}
                size="lg"
            >
                <form
                    id=""
                    className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
                    onSubmit={formik.handleSubmit}
                >
                    <Modal.Header>
                        <Modal.Title className="">
                            <span className="font-weight-bolder text-warning">
                                Order ID :{props.data.confirmGoodsId}
                            </span>
                        </Modal.Title>
                        {props.data?<span className="font-weight-bolder text-primary text-right">
                            {props.data.orderType === "Hold Request"?<span className="label label-light-warning label-pill label-inline font-weight-bold text-nowrap">Hold Request</span>:
                            props.data.orderType === "Buy Request"?<span className="label label-light-success label-pill label-inline font-weight-bold text-nowrap">Buy Request</span>:""}
                        </span>:""}
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            {/* <div className="col-12">
                                Please accept all conditions or mention the reason in comment box to approve
                                {errmessage ? <Alert variant="danger"> {errmessage} </Alert>:""}
                            </div> */}
                            <div className="col-12 mt-5">
                                <div className="row">
                                    {props?.data?<div className="col-12 border-bottom">
                                    <div className="table-responsive custom-scrollbar w-100 mt-4">
                                    <table className="table" >
                                    <thead className="thead-light">
                                    <tr>
                                        <th  className="text-center text-nowrap align-middle">
                                                Diamond Detail
                                        </th> 
                                        <th  className="text-center text-nowrap align-middle">
                                                Advanced tags
                                        </th> 
                                        <th  className="text-center text-nowrap align-middle">
                                                Price
                                        </th>    
                                        <th  className="text-center text-nowrap align-middle">
                                                Date & Time
                                        </th>                  
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr >
                                    <td className="text-center align-middle text-nowrap">
                                    {props.data.diamondType === "PN" || props.data.diamondType === "PL" ? 
                                    <div className="row">
                                        <div className="col-2 text-center p-0">
                                            <img
                                                className="img-fluid mr-2"
                                                alt={props.data.cShape}
                                                src={toAbsoluteUrl(`/media/shape/svg_shape/parcel/${props.data.cShape.toLowerCase()}.svg`)}
                                                width="50px"
                                                onError={e => {
                                                    e.currentTarget.src = toAbsoluteUrl(
                                                        `/media/shape/svg_shape/parcel/other.svg`
                                                        )
                                                    }}
                                            />
                                        </div>
                                        <div className="col-10 pl-2 p-0 text-left">
                                            <div className={`mb-1 ${props.data.diamondType === "PN" ? "natTab" : "labTab"}`}>
                                                <span className={`${props.data.diamondType}_diamond mr-2 small`}>
                                                    {props.data.diamondType}
                                                </span>
                                                <span className={`text-primary small ml-3`}>
                                                    {props.data.diamondType}-{props.data.parcelId}-{props.data.splitId}{props.data.cgSplitId ?<>/{props.data.cgSplitId}</> : ""}
                                                </span>
                                                <span className={`text-primary text-capitalize small ml-3`}>
                                                    {props.data.lengthMm} - {props.data.widthMm} MM
                                                </span>
                                            </div>

                                            <span className="text-dark font-weight-bold d-block">
                                                {props.data.cShape}{" "}
                                                {(props.data.cWeight)?.toFixed(2)}Ct.{" "}
                                                {props.data.cColor}{" "}
                                                {props.data.cClarity}{" "}{props.data.cCut}{" "}{props.data.cPolish}{" "}{props.data.cSymmetry}{" "}
                                                {props.data.cFluorescence}
                                            </span>
                                        </div>
                                    </div>
                                :
                                    <div className="row">
                                        <div className="col-2 text-center p-0">
                                        {props.data.image &&  props.data.image !=="null" ? (
                                                <img
                                                    className="img-fluid mr-2"
                                                    alt={props.data.cShape}
                                                    src={props.data.image}
                                                    width="50px"
                                                    onError={e => toAbsoluteUrl(
                                                        e.currentTarget.src = `/media/shape/${props.data.cShape ? props.data.cShape.toLowerCase() : ""}-no.png`
                                                    )}
                                                />
                                            ) : (
                                                <img
                                                    className="img-fluid mr-2"
                                                    alt={props.data.cShape}
                                                    src={toAbsoluteUrl(
                                                        `/media/shape/${props.data.cShape ? props.data.cShape.toLowerCase() : ""}-no.png`
                                                    )}
                                                    onError={e => {
                                                        e.currentTarget.src = toAbsoluteUrl(
                                                            `/media/General/NoDiamondImage.svg`
                                                        )
                                                    }}
                                                    width="50px"
                                                    style={{ backgroundColor: "#f4f4f4" }}
                                                />
                                            )}
                                        </div>
                                        <div className="col-10 pl-2 p-0 text-left">
                                            <div className={`mb-1 ${props.data.diamondType === "W" || props.data.diamondType === "N" ? "natTab" : "labTab"}`}>
                                                <Availability  availability={props.data.availability}/>
                                                <DiamondTypeTag diamondTypeTagColor={props.data.diamondTypeTagColor} diamondTypeTag={props.data.diamondTypeTag}/>
                                                <span  className={`text-primary small ml-3`}>
                                                    {props.data.loatNO}
                                                </span>
                                                <CertificateLink Certificate_link={props.data.certificate_link} lab={props.data.lab} certificate={props.data.certiNo} className={`text-primary mx-2 small`} />
                                            </div>

                                            <span className="text-dark font-weight-bold d-block">
                                                {props.data.cShape}{" "}
                                                {(props.data.cWeight)?.toFixed(2)}Ct.{" "}
                                                {props.data.cColor === "fancy" ? (
                                                    <>
                                                        {props.data.fIntensity}{" "}{props.data.fOvertone}{" "}{props.data.fColor}{" "}
                                                    </>
                                                ) : (
                                                    <>{props.data.cColor}{" "}</>
                                                )}
                                                {props.data.cClarity}{" "}{props.data.cCut}{" "}{props.data.cPolish}{" "}{props.data.cSymmetry}{" "}
                                                {props.data.cFluorescence}
                                            </span>
                                        </div>
                                    </div>
                                    }    
                                    </td>  
                                    <td className="text-center align-middle  text-nowrap">
                                        <AdvancedTag {...props.data}/>
                                    </td>
                                    <td className="text-center align-middle  text-nowrap">
                                    <span className="font-weight-bolder text-primary">
                                        ${parseFloat(props.data.oRate * props.data.cWeight)?.toFixed(2)}
                                    </span>{" "}
                                    <br />
                                    <span className="text-muted small">
                                        $/CT ${parseFloat(props.data.oRate)?.toFixed(2)}
                                    </span>
                                    </td>
                                    <td className="text-center align-middle  text-nowrap">
                                        {props.data.createdDate}
                                    </td>
                                    </tr>
                                    </tbody>
                                    </table>
                                    </div>  
                                    </div>:""}
                                    <div className="col-12 mt-5 pl-md-15">
                                    {Object.entries(UiData).map(([key, value]) => (
                                        <>
                                        {/* {JSON.stringify(value.options)} */}
                                        {value.type === "select"?
                                        <div className={`form-group mb-1 ${!formik.values[key]?"text-danger":""}`}>
                                        <div className="row align-items-center">
                                                <p className="mb-0 ml-3">{value.name}{" "} 
                                                {value.overlay?<OverlayTrigger 
                                            placement="bottom" 
                                            overlay={
                                                <Tooltip>
                                                <span className="d-inline-block">
                                                    {value.overlay}
                                                </span>
                                                </Tooltip>
                                            }>
                                            <span className="text-secondary"><FaInfoCircle className="ml-2 cursor-pointer" /></span>
                                            </OverlayTrigger>:""}{" "}  
                                                {formik.values[`${key}Edit`] ? getChipStyles(value.options,formik.values[key]) : ""}</p>
                                               { formik.values[`${key}Edit`] &&
                                                    <span className="btn btn-icon btn-clear btn-sm" 
                                                        onClick={() => {
                                                            formik.setFieldValue(`${key}Edit`, !formik.values[`${key}Edit`]);
                                                        }}
                                                    ><FaEdit className="font-size-h5 text-primary"/></span>
                                                }
                                            {!formik.values[`${key}Edit`] && (
                                                <div className="col-md-5">
                                                    <Select
                                                    menuPortalTarget={document.body}
                                                    styles={customShadeStyles(value.options.find(val => val.value === formik.values[key]))}
                                                    name={key}
                                                    options={value.options}
                                                    className={`${getInputClasses(`${key}`)}`}
                                                    onChange={(selected) => {
                                                        formik.setFieldValue(key, selected ? selected.value : null); // Ensure to handle the case when selected is null
                                                        formik.setFieldValue(`${key}Edit`, true);
                                                    }}
                                                    value={value.options.find(val => val.value === formik.values[key])}
                                                    components={{ Option: CustomOption }}
                                                />
                                                {formik.touched[key] && formik.errors[key] ? (
                                                    <div className="invalid-feedback small">
                                                        {formik.errors[key]}
                                                    </div>
                                                ) : null}
                                                </div>
                                            )}
                                        </div>
                                        </div>:
                                        value.type === "multiselect"?
                                        <div className={`form-group mb-1 ${!formik.values[key]?"text-danger":""}`}>
                                        <div className="row align-items-center">
                                            <p className="mb-0 ml-3">{value.name}{" "}
                                            {value.overlay?<OverlayTrigger 
                                            placement="bottom" 
                                            overlay={
                                                <Tooltip>
                                                <span className="d-inline-block">
                                                    {value.overlay}
                                                </span>
                                                </Tooltip>
                                            }>
                                            <span className="text-secondary"><FaInfoCircle className="ml-2 cursor-pointer" /></span>
                                            </OverlayTrigger>:""}{" "}
                                            {formik.values[`${key}Edit`]?formik?.values[key]?.split(", ").map((val => {
                                                return(
                                                    getChipStyles(value.options,val)
                                                )
                                            })):""} </p>
                                            
                                            
                                            
                                            { formik.values[`${key}Edit`]?
                                                <span className="btn btn-icon btn-clear btn-sm" 
                                                    onClick={() => {
                                                        formik.setFieldValue(`${key}Edit`, !formik.values[`${key}Edit`]);
                                                    }}
                                                ><FaEdit className="font-size-h5 text-primary"/></span>:
                                                ""
                                            }

                                            {!formik.values[`${key}Edit`] && (
                                                <div className="col-md-5">
                                                <Select
                                                  isMulti
                                                  menuPortalTarget={document.body}
                                                  styles={customOpenStyles(value.options,value.options.find(val => val.value === formik.values[key]))} // Make sure you have this style function defined
                                                  name={key}
                                                  options={value.options}
                                                  className={`${getInputClasses(key)}`}
                                                  onChange={(selected,changevalue) => {
                                                    let selectedValues = selected ? selected.map(option => option.value) : [];
                                                    const hasSelectionRule = selected.some(item => 'selectionRule' in item);
                                                    if(hasSelectionRule){
                                                        const getReplaceAll = selected.filter(val => val.selectionRule === "replaceAll")
                                                        if(changevalue?.option?.selectionRule === "replaceAll"){
                                                            selectedValues = [changevalue?.option?.value]
                                                        } 
                                                        else if(getReplaceAll.length){
                                                            for(let i = 0; i < getReplaceAll.length; i++){
                                                                selectedValues = selectedValues.filter(val => val !== getReplaceAll[i].value)
                                                            }
                                                        }
                                                        else if(changevalue?.option?.selectionRule === "replaceSome" && changevalue?.option?.replaceValues?.length){
                                                            for(let i = 0; i < changevalue?.option?.replaceValues.length;i++){
                                                                selectedValues = selectedValues.filter(val => val !== changevalue?.option?.replaceValues[i])
                                                            }
                                                        }    
                                                    }
                                                    formik.setFieldValue(key, selectedValues.join(", "));
                                                    
                                                    // formik.setFieldValue(formik.values[`${key}Edit`], true);
                                                  }}
                                                  components={{ Option: CustomOption }} // Ensure you have this custom component
                                                  value={value.options.filter(option => 
                                                    formik.values[key]?.split(", ").includes(option.value)
                                                  )}
                                                  closeMenuOnSelect={false}
                                                />
                                                {formik.touched[key] && formik.errors[key] ? (
                                                  <div className="invalid-feedback small">
                                                    {formik.errors[key]}
                                                  </div>
                                                ) : null}
                                              </div>
                                            )}
                                            {!formik.values[`${key}Edit`]?<button className="btn btn-icon btn-clear btn-sm" 
                                                        onClick={() => {
                                                            formik.setFieldValue(`${key}Edit`, !formik.values[`${key}Edit`]);
                                                        }}
                                                        disabled={!formik.values[key]}
                                                    ><FaSave className="font-size-h5 text-primary"/></button>:""}
                                        </div>
                                    </div>:
                                    value.type === "text"?
                                    <div className={`form-group mb-1 ${!formik.values[key]?"text-danger":""}`}>
                                    <div className="row align-items-center">
                                        <p className="mb-0 ml-3">{value.name}{" "}
                                        {value.overlay?<OverlayTrigger 
                                        placement="bottom" 
                                        overlay={
                                            <Tooltip>
                                            <span className="d-inline-block">
                                                {value.overlay}
                                            </span>
                                            </Tooltip>
                                        }>
                                        <span className="text-secondary"><FaInfoCircle className="ml-2 cursor-pointer" /></span>
                                        </OverlayTrigger>:""}{" "}
                                        </p>
                                        <div className="col-md-4">
                                        <input
                                            type="text"
                                            placeholder={value.placeholder}
                                            className={`form-control form-control-sm mb-2 ${!formik.values[key]?"red-placeholder":""} ${getInputClasses(
                                                key
                                            )}`}
                                            style={{backgroundColor:!formik.values[key]?"#ffe2e5":""}}
                                            name={key}
                                            {...formik.getFieldProps(key)}
                                            onChange={(e) => {
                                                formik.setFieldValue(key, e.target.value);
                                            }}
                                        />
                                            {formik.touched[key] && formik.errors[key] ? (
                                              <div className="invalid-feedback small">
                                                {formik.errors[key]}
                                              </div>
                                            ) : null}
                                          </div>
                                    </div>
                                </div>:""}
                                    </>    
                                    ))}
                                        
                                    </div>
                                    {Object.entries(UiData).map(([key, value]) => (
                                        <>
                                        {value.type === "comment"?
                                        <div className="col-12">
                                        <div className="form-group mt-3 mb-1">
                                            <label htmlFor={key}>
                                                {value.name}
                                            </label>
                                            <textarea
                                                className={`form-control ${getInputClasses({key})}`}
                                                name={key}
                                                id={key}
                                                placeholder={key}
                                                rows="3"
                                                {...formik.getFieldProps(`${key}`)}
                                            ></textarea>
                                        </div>
                                        {formik.touched[key] && formik.errors[key] ? (
                                                <div className="fv-plugins-message-container">
                                                    <div className="fv-help-block">
                                                        {formik.errors[key]}
                                                    </div>
                                                </div>
                                            ) : null}
                                    </div>:""}
                                    </>    
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="py-3 justify-content-between">
                        <Button
                            variant="danger"
                            className="font-weight-bold"
                            onClick={() => closeModel(props)}
                        >
                            Close
                        </Button>
                        <button
                            type="submit"
                            className={`btn btn-${props.data.statsusid?"primary":"danger"} font-weight-bold px-9`}
                        >
                            {props.data.statsusid?
                            <span>{`Approve ${props.data.orderType}`} </span>:
                            <span>{`Decline ${props.data.orderType}`} </span>}
                            {loading && (<span className="ml-3 spinner spinner-white"></span>)}
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </div>
    );
};
